import React from 'react';
import BlazeLink from '../BlazeLink';
import LazyImage from '../LazyImage';

const SearchContentItems = ({ results = [], onClick }) =>
  results.map(item => {
    if (!item || !item.url) return null;

    const { id, name, image, url } = item;

    return (
      <BlazeLink href={url} onClick={onClick} key={id}>
        <div className="search-content--results__wrapper">
          {image?.url ? (
            <LazyImage
              src={image.url}
              alt={name}
              className="search-content--results__image"
              sizeKey="search-result"
            />
          ) : null}
          <span className="search-content--results__title">{name}</span>
        </div>
      </BlazeLink>
    );
  });

export default SearchContentItems;
